import { defineMessages } from 'react-intl';

export default defineMessages({
    yearsAffiliatedEmployer: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.yearsAffiliatedEmployer',
        defaultMessage: 'How many years have you been employed here?'
    },
    yearsAffiliatedAssociation: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.yearsAffiliatedAssociation',
        defaultMessage: 'How many years have you been a member or affiliated?'
    },
    additionalInfoHeader: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.additionalInfoHeader',
        defaultMessage: 'Please provide the additional information in order to proceed'
    },
    employmentStatus: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.employmentStatus',
        defaultMessage: 'Employment Status'
    },
    membershipStatus: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.membershipStatus',
        defaultMessage: 'Membership Status'
    },
    yearsAffiliatedPlaceholder: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.yearsAffiliatedPlaceholder',
        defaultMessage: '#'
    },
    partOfManagement: {
        id: 'ml.quoteandbind.common.employersaffiliationseligibility.partOfManagement',
        defaultMessage: 'Are you part of management?'
    },
    toggleYes: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.toggleYes',
        defaultMessage: 'Yes'
    },
    toggleNo: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.toggleNo',
        defaultMessage: 'No'
    },
    temporaryEmployee: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.temporaryEmployee',
        defaultMessage: 'Are you a temporary employee?'
    },
    alternateId: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.alternateId',
        defaultMessage: 'Alternate Id'
    },
    ssn: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    ssnOptional: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.Social Security Number (optional)',
        defaultMessage: 'Social Security Number (optional)'
    },
    whyEnterSSN: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.why enter SSN',
        defaultMessage: 'Why enter SSN?'
    },
    ssnToolTip: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.ssnToolTip',
        defaultMessage: 'You may choose to enter the information above to verify your eligibility for the employer discount. You may continue to quote without entering this information as well as confirm eligibility again later.'
    },
    enterAboveMsg: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.enterAboveMsg',
        defaultMessage: 'Enter the information above to check eligibility for our group program. Or, you may continue without providing it.'
    },
    verifyWarningMsg: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.verifyWarningMsg',
        defaultMessage: 'Please review your information. You can continue with this quote or contact us for assistance.'
    },
    promoCode: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.promoCode',
        defaultMessage: 'If an offer or promotional code is shown on the correspondence, please enter it here'
    },
    loadingUpdate: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.loadingUpdate',
        defaultMessage: 'Loading...'
    },
    loadingEligibility: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.loadingEligibility',
        defaultMessage: 'Checking Eligibility'
    },
    employeeNumber: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.employeeNumber',
        defaultMessage: 'Employee Number'
    },
    departmentNumber: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.departmentNumber',
        defaultMessage: 'Department Number'
    },
    last4SSN: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.last4SSN',
        defaultMessage: 'Last 4 Digits of SSN'
    },
    altIdVerif: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.altIdVerif',
        defaultMessage: 'Alternate ID Verification'
    },  
    ssnValidation: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.ssnValidation',
        defaultMessage: 'Please provide the last 4 digits of your SSN.'
    },
    altIdVerifError: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.altIdVerifError',
        defaultMessage: 'Please provide the correct {altIDLabel} to confirm eligibility, otherwise click next to continue with other payment options.'
    },
    last4SSNVerifError: {
        id: 'ml.quoteandbind.common.employeraffilitationsummary.last4SSNVerifError',
        defaultMessage: 'last 4 digits of SSN'
    }            
})